import { ref } from 'vue'

// Inches of extra lift each shelf type hands to the shelves above it, keyed by the mesh names normalizeShelfName produces. Seeded from Cave's SHELF_SPACING values rather than importing them: the tables started identical, but Hybrid's are being retuned against the real rig and Cave's must not move with them.
export const HYBRID_SHELF_SPACING_DEFAULTS: Readonly<Record<string, number>> = {
  'medball shelf'    : 4,
  'dumbbell shelf'   : 4,
  'kettlebell shelf' : 2,
  'liner'            : 2,
  'bumper'           : 8,
  'panel'            : 0,
}

// A ref rather than a plain object so HybridShelfBuilder's read registers with the rackbuilderScene computed - setting it re-renders the rig in place, keeping the configuration the tuner is looking at.
export const hybridShelfSpacing = ref<Record<string, number>>({ ...HYBRID_SHELF_SPACING_DEFAULTS })

// Tuning scaffolding, browser-only: window.__hybridShelves.set({ 'medball shelf': 8 }) from the console retunes a live rig. Delete this file's window block and inline the table above once the numbers are settled.
export const hybridShelfTuner = {
  get: () => ({ ...hybridShelfSpacing.value }),

  set(spacing: Record<string, number>) {
    hybridShelfSpacing.value = { ...hybridShelfSpacing.value, ...spacing }

    return this.get()
  },

  setAll(inches: number) {
    return this.set(Object.fromEntries(Object.keys(hybridShelfSpacing.value).map(name => [name, inches])))
  },

  reset() {
    hybridShelfSpacing.value = { ...HYBRID_SHELF_SPACING_DEFAULTS }

    return this.get()
  },
}

if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).__hybridShelves = hybridShelfTuner
}
